import React, { useEffect, useRef } from "react";

let tvScriptLoadingPromise;
let instanceCount = 0;

const Chart = ({ className }) => {
  const onLoadScriptRef = useRef();
  const containerIdRef = useRef(`tradingview_${instanceCount++}`);

  useEffect(() => {
    onLoadScriptRef.current = createWidget;

    if (!tvScriptLoadingPromise) {
      tvScriptLoadingPromise = new Promise((resolve) => {
        const script = document.createElement("script");
        script.id = "tradingview-widget-loading-script";
        script.src = "https://s3.tradingview.com/tv.js";
        script.type = "text/javascript";
        script.onload = resolve;

        document.head.appendChild(script);
      });
    }

    tvScriptLoadingPromise.then(
      () => onLoadScriptRef.current && onLoadScriptRef.current()
    );

    return () => (onLoadScriptRef.current = null);

    function createWidget() {
      if (
        document.getElementById(containerIdRef.current) &&
        "TradingView" in window
      ) {
        new window.TradingView.widget({
          autosize: true,
          symbol: "NASDAQ:AAPL",
          interval: "D",
          timezone: "Etc/UTC",
          theme: "dark",
          style: "1",
          locale: "en",
          toolbar_bg: "#f1f3f6",
          enable_publishing: false,
          allow_symbol_change: true,
          container_id: containerIdRef.current,
        });
      }
    }
  }, []);

  return (
    <section className="chart-section">
      <div className="target-2" id="chart"></div>
      <div>
        <div className="chart-wrap h-full">
          <div className="tradingview-widget-container">
            <div id={containerIdRef.current} className={className} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Chart;
